export const postTypeLabel = (post_type = "Post") => {
    if(post_type == 'Post::JobUpdates')
    return "Job Update"

    return "News"
}